{
  "language": {
    "label": "Idioma",
    "select": "Seleccionar idioma"
  },
  "nav": {
    "howItWorks": "Cómo funciona",
    "programmes": "Programas",
    "pricing": "Precios",
    "contact": "Contáctanos",
    "admin": "Administración",
    "resources": "Recursos para familias",
    "reviews": "Opiniones de familias",
    "signIn": "Acceso para familias",
    "portal": "Portal de familias",
    "book": "Reserva una evaluación gratis",
    "terms": "Términos y condiciones",
    "refund": "Política de reembolso",
    "privacy": "Aviso de privacidad",
    "tagline": "Inglés premium en línea para los más pequeños"
  },
  "hero": {
    "title": "Clases de inglés en línea para niños de 4 a 12 años que desarrollan fluidez real al hablar",
    "rating": "Profesora certificada CELTA · Graduada en Inglés y Psicología",
    "credential": "Profesora certificada CELTA",
    "subtitleBefore": "Clases de inglés en vivo para niños de 4 a 12 años, con un máximo de 5 alumnos por clase y más del 80% de tiempo hablando. El progreso se mide con nuestro",
    "subtitleLink": "plan de estudios alineado al MCER",
    "ctaPrimary": "Reserva una evaluación gratis",
    "ctaSecondary": "Ver precios de matrícula",
    "liveLesson": "Clase en vivo · Grupo A1",
    "imageAlt": "Tres niños riendo y hablando durante una clase de inglés en línea en vivo de Smart Word Labs"
  },
  "approach": {
    "heading": "Grupos pequeños. Gran confianza al hablar.",
    "link": "Descubre cómo funciona nuestro método paso a paso"
  },
  "programmes": {
    "heading": "Programas por edad y nivel",
    "intro": "Cada matrícula comienza con una evaluación gratuita y un plan de aprendizaje por escrito. Los niños se ubican en un micro-grupo acorde a su edad y nivel MCER, mientras que IELTS Mastery ofrece clases privadas individuales para candidatos de cualquier edad.",
    "cefrLabel": "Nivel MCER",
    "cefr": "MCER {{level}}",
    "lessonLength": "Duración de la clase",
    "cohortSize": "Tamaño del grupo",
    "speakingTime": " · más del 80% hablando",
    "explore": "Descubre {{title}}",
    "exploreAria": "Ver todos los detalles de {{title}} para {{band}}",
    "bookAria": "Reserva una evaluación gratuita de inglés para {{title}}, {{band}}",
    "book": "Reserva una evaluación gratis",
    "compareAll": "Compara todos los programas en detalle",
    "items": {
      "early-phonics-explorers": {
        "band": "4 a 6 años",
        "title": "Exploradores de Fonética",
        "summary": "Clases de inglés en línea para niños de 4 a 6 años: fonética sintética, primeras palabras y confianza al hablar en un micro-grupo de cinco.",
        "duration": "Clases de 30 minutos",
        "cohort": "Máx. 5 niños",
        "spots": "Máx. 5 niños por grupo"
      },
      "literacy-builders": {
        "band": "7 a 9 años",
        "title": "Constructores de Lectoescritura",
        "summary": "Clases de inglés en grupos reducidos para niños de 7 a 9 años: fluidez lectora, escritura estructurada y conversación cotidiana, alineadas al MCER A1–A2.",
        "duration": "Clases de 45 minutos",
        "cohort": "Máx. 5 niños",
        "spots": "Máx. 5 niños por grupo"
      },
      "confident-communicators": {
        "band": "10 a 12 años",
        "title": "Comunicadores Seguros",
        "summary": "Un curso de inglés MCER para niños de 10 a 12 años que desarrolla la redacción de ensayos, el debate y las entrevistas de cara a secundaria.",
        "duration": "Clases de 45 minutos",
        "cohort": "Máx. 5 niños",
        "spots": "Máx. 5 niños por grupo"
      },
      "ielts-mastery": {
        "band": "Todas las edades",
        "title": "IELTS Mastery individual",
        "summary": "Preparación privada de IELTS Academic o General Training para cualquier edad, centrada en tu puntuación objetivo y la fecha del examen.",
        "duration": "Clases de 45 minutos",
        "cohort": "Individual",
        "spots": "Clases privadas 1 a 1"
      }
    }
  },
  "pricing": {
    "heading": "Precios mensuales sencillos",
    "headingPage": "Precios de las clases de inglés en línea para niños",
    "intro": "Una cuota mensual por niño, facturada cada mes y cancelable en cualquier momento. La clase de evaluación y el plan de aprendizaje son siempre gratuitos.",
    "introTeaser": "Una cuota mensual por niño, facturada cada mes y cancelable en cualquier momento. La evaluación gratuita y el plan de aprendizaje por escrito están incluidos en todos los planes.",
    "mostPopular": "Más popular",
    "perMonth": "USD / mes",
    "perLesson": "{{amount}} USD por clase",
    "subscribe": "Suscribirse",
    "signInToSubscribe": "Inicia sesión para suscribirte",
    "seeMore": "Consulta lo que incluye cada plan en la página de precios",
    "noteLessonLength": "La duración varía según la edad: 30 minutos de 4 a 6 años y 45 minutos de 7 a 12 años.",
    "noteCohorts": "Las clases son a las 9, 10 y 11 a. m. y a las 2, 3, 4, 5 y 6 p. m., hora de Toronto (ET). Tu horario exacto se confirma durante la evaluación gratuita.",
    "noteSibling": "La matrícula de hermanos ahorra un 10% por cada niño adicional. Precios en USD.",
    "tiers": {
      "cohort_starter_monthly": {
        "name": "Grupo Starter",
        "lessons": "8 clases / mes",
        "cadence": "2 clases por semana",
        "features": [
          "Micro-grupo de máximo 5 niños",
          "Clases en vivo de 45 minutos, 2 veces por semana",
          "Tareas semanales con comentarios de la profesora",
          "Informe mensual de progreso MCER",
          "Mensajería directa con Ms. Salma",
          "2 créditos de cambio de horario al mes"
        ]
      },
      "cohort_intensive_monthly": {
        "name": "Grupo Intensivo",
        "lessons": "16 clases / mes",
        "cadence": "4 clases por semana",
        "features": [
          "Micro-grupo de máximo 5 niños",
          "Clases en vivo de 45 minutos, 4 veces por semana",
          "Tareas semanales con comentarios de la profesora",
          "Informe mensual de progreso MCER",
          "Mensajería directa con Ms. Salma",
          "4 créditos de cambio de horario al mes",
          "Prioridad en la asignación de grupo"
        ]
      },
      "private_1on1_monthly": {
        "name": "Privado individual",
        "lessons": "16 clases / mes",
        "cadence": "4 clases por semana",
        "features": [
          "Clases individuales, sin grupo — plan de estudios totalmente personalizado",
          "Clases en vivo de 45 minutos, 4 veces por semana",
          "Tareas semanales con comentarios de la profesora",
          "Informe mensual de progreso MCER",
          "Mensajería directa con Ms. Salma",
          "Reprogramación flexible (sin límite mensual)",
          "Ritmo personalizado según los objetivos del niño"
        ]
      },
      "ielts_mastery_1on1_monthly": {
        "name": "IELTS Mastery individual",
        "lessons": "16 clases / mes",
        "cadence": "4 clases por semana",
        "features": [
          "Abierto a todas las edades — sin límite de edad",
          "Preparación específica para IELTS Academic o General",
          "Clases individuales, sin grupo — estrategia personalizada para tu puntuación objetivo",
          "Sesiones intensivas de 45 minutos de Speaking, Reading, Writing y Listening",
          "Evaluaciones detalladas de las Tareas 1 y 2 con puntuación estimada",
          "Simulacros de Speaking individuales con comentarios estilo examinador",
          "Práctica dirigida de Reading y Listening con análisis de errores y gestión del tiempo",
          "Mensajería directa con Ms. Salma",
          "Reprogramación flexible (sin límite mensual)",
          "Ritmo personalizado según la fecha de tu examen"
        ]
      },
      "starter_pack_onetime": {
        "name": "Starter Pack",
        "lessons": "4 clases privadas 1 a 1",
        "cadence": "30 minutos cada una",
        "features": []
      }
    },
    "oneTime": "USD pago único",
    "getStarterPack": "Obtener el Starter Pack",
    "starterNote": "Prueba 4 clases antes de comprometerte. Si te inscribes en 30 días, los $79 completos se acreditan a tu primer mes."
  }
}
